import { useState, useEffect, useContext } from 'react';
import { Chains } from 'api/types/httpsTypes/d-wallets';
import { WebSocketContext } from 'api/services/websocket/websocketProvider';

interface TokenPriceMessage {
  p: string; // Price
  c: Chains; // Chain
  a: string; // Address
}

export const useTokenPrice = (
  chain: Chains,
  address: string
): string | null => {
  const wsContext = useContext(WebSocketContext);
  const [price, setPrice] = useState<string | null>(null);

  useEffect(() => {
    if (!wsContext) return;

    const dataKey = { chain, address };

    // ✅ Load from WebSocket message cache if available
    const cached = wsContext.getLatestMessage('token_price', dataKey);
    if (cached?.data) {
      const parsed = cached.data as TokenPriceMessage;
      if (parsed.c === chain && parsed.a === address) {
        setPrice(parsed.p);
      }
    }

    // ✅ Listen for updates
    const handleMessage = (msg: any) => {
      try {
        const parsed = msg.data as TokenPriceMessage;

        if (parsed.c === chain && parsed.a === address) {
          setPrice(parsed.p);
        }
      } catch (err) {
        console.error('❌ Error parsing token price message:', err);
      }
    };

    wsContext.addMessageListener('token_price', dataKey, handleMessage);
    return () => {
      wsContext.removeMessageListener('token_price', dataKey, handleMessage);
    };
  }, [wsContext, chain, address]);

  return price;
};
